export const ADD_MAIN_CONTROLS_NAMESPACE = 'addMainControls';
export const ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE = 'addFocusDrawerControls';
export const ADD_OVERLAY_CONTROLS_NAMESPACE = 'addOverlayControls';
export const MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSING_ANIMATION = 7000;
export const MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSE = 1000;
